module.exports = "<button class=\"{{iconType}}\" (click)=\"iconEmit(this)\"></button>"